import { AbstractApiService } from "../abstractions/AbstractApiService";
import { OnRequestSuccess, OnRequestError } from "./Responses";
import { IClinic } from "../models/IClinic";

export class ClinicService extends AbstractApiService {
    constructor() {
        super();
    }

    public CreateNewClinic(clinic: IClinic, onSuccess: OnRequestSuccess, onError: OnRequestError): void {
        this.Post('api/clinic/createnewclinic', clinic, onSuccess, onError);
    }

    public RemoveClinic(clinicId: number, onSuccess: OnRequestSuccess, onError: OnRequestError): void {
        this.Post('api/clinic/removemyclinic', clinicId, onSuccess, onError);
    }

    public GetMyClinicsList(onSuccess: OnRequestSuccess, onError: OnRequestError): void {
        this.Get('api/clinic/myclinics', onSuccess, onError);
    }

    public AddOrUpdateMyClinic(clinic: IClinic, onSuccess: OnRequestSuccess, onError: OnRequestError): void {
        this.Post('api/clinic/addorupdatemyclinic', clinic, onSuccess, onError);
    }

    public SearchClinics(searchValue: string, onSuccess: OnRequestSuccess, onError: OnRequestError): void {
        this.Get('api/clinic/searchclinics?searchValue=' + encodeURI(searchValue), onSuccess, onError);
    }

    public GetPhysiotherapistsClinics(physiotherapistId: string, onSuccess: OnRequestSuccess, onError: OnRequestError) {
        this.Get('api/clinic/getphysiotherapistsclinics?physiotherapistId=' + physiotherapistId,
            onSuccess,
            onError);
    }

    public GetClinic(clinicId: number, onSuccess: OnRequestSuccess, onError: OnRequestError) {
        this.Get('api/clinic/getclinicinfo?clinicId=' + clinicId.toString(), onSuccess, onError);
    }

    public GetMyClinicsBasicInfo(onSuccess: OnRequestSuccess, onError: OnRequestError) {
        this.Get('api/clinic/getmyclinicsbasicinfo', onSuccess, onError);
    }

    public GetMyClinicsForEdit(onSuccess: OnRequestSuccess, onError: OnRequestError) {
        this.Get('api/clinic/getmyclinicsforedit', onSuccess, onError);
    }

    public GetClinicForEdit(clinicId: number, onSuccess: OnRequestSuccess, onError: OnRequestError) {
        this.Get('api/clinic/getclinicforedit?clinicId=' + clinicId.toString(), onSuccess, onError);
    }

    public SearchClinicLocalizations(searchValue: string, onSuccess: OnRequestSuccess, onError: OnRequestError): void {
        this.Get('api/clinic/searchcliniclocalizations?searchValue=' + encodeURI(searchValue), onSuccess, onError);
    }

    public PhysiotherapistHasAnyClinic(onSuccess: OnRequestSuccess, onError: OnRequestError) {
        this.Get('api/clinic/physiotherapisthasanyclinics', onSuccess, onError);
    }

    public GetClinicForVisit(clinicId: number, physiotherapistId: string, onSuccess: OnRequestSuccess, onError: OnRequestError) {
        this.Get('api/clinic/getclinicforvisit?physiotherapistId='
            + physiotherapistId
            + '&clinicId='
            + clinicId.toString(),
            onSuccess,
            onError);
    }
}


// WEBPACK FOOTER //
// ./src/services/ClinicService.tsx